export enum LookbackWindow {
  Days30 = '30',
  Days60 = '60',
  Days90 = '90',
  Days180 = '180',
  Days365 = '365',
}
